import { useEffect } from 'react';
import type { TsoInterfaceSettingsResponse } from 'src/apis/transport-auction/types';
import type { OptionalTransportAuctionServiceRootRequest } from 'src/apis/transport-auction/use-transport-auction-service-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  transportAuctionService: OptionalTransportAuctionServiceRootRequest;
};

type ExecuteProps = {
  url: string;
};

export function useTsoInterfaceSettings({
  transportAuctionService,
}: HookOptions) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<TsoInterfaceSettingsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  const url =
    transportAuctionService?.response?.data._links.interfaceSettings?.href;

  useEffect(() => {
    if (!url) return;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return request;
}

export type TsoInterfaceSettingsRequest = ReturnType<
  typeof useTsoInterfaceSettings
>;
